<!-- 饼图 -->
<template>
    <div>
        <div class="chart_Title" style="width:100%;align-items: center;" :style = "{ background: 'url(' +commenUrl+ baseConfig.title?.textRgb + ') no-repeat',backgroundSize:'100%',display:baseConfig?.title?.textShow?'flex':'none', height: baseConfig.title?.Height + 'px'}">
            <div class="img-icon" :style = "{ width: baseConfig.title?.textWidth + 'px', height: baseConfig.title?.textHeight + 'px', marginLeft: baseConfig.title?.textLeft + 'px', marginRight: baseConfig.title?.textRight + 'px',display:baseConfig?.title?.textIcon?'block':'none'}">
                <img style="height:100%;width:100%" :src="commenUrl+baseConfig?.title?.textIcon" alt="">
            </div>
            <div style="flex:1" :style = "{ fontSize: baseConfig.title?.textSzie + 'px', color: baseConfig.title?.textColor,textAlign: baseConfig.title?.textAlign}">{{baseConfig?.title?.textTitle}}</div>
        </div>
        <div class="chart_box" id='chart_box' :class="baseConfig.animation"  :style = "{ width: baseConfig.width + 'px', height: baseConfig.height + 'px'}">
        <div id="main" class="chart1" ref='barChartRef' :style = "{ left: baseConfig.left + 'px',top: baseConfig.top + 'px'}"></div>
    </div>
    </div>
</template>

<script>
import { getCurrentInstance,ref,onMounted,onUnmounted,watch,shallowRef,computed } from "vue";
import * as echarts from 'echarts';
import { useStore } from 'vuex';
export default {
    props: {
        index: {
            type:Number ,
            default: function () { return {} }
        },
        yearRef:{
            type: String,
            default: function () { return "2024" }
        }
    },
    setup(props) {
       
        const { proxy } = getCurrentInstance();
        const store = useStore();
        const index = ref(props.index);
        const baseConfig = ref({})
        const componentList = ref(computed(() => store.state.chartData.componentList));
        baseConfig.value = componentList.value[index.value].config.baseConfig
        const chartData=ref(computed(() => store.state.chartData))
        const project = ref(computed(() => store.state.project));
        const option = ref({})
        const danwei=ref()
        const barChartRef = shallowRef(null);
        const chartInstance = shallowRef(null);
        const handleResize = () => {
            chartInstance.value.resize();
        };
        watch(() => store.state.chartData.componentList[index.value].config.options,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
                if(newVal){
                    chartInit()
                }
            },{ deep: true }
        )
        watch(() => store.state.chartData.componentList[index.value].data,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
                if(newVal){
                    chartInit()
                }
            },{ deep: true }
        ) 
        watch(() => store.state.chartData.componentList[index.value].config.baseConfig,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
                if(newVal){
                    baseConfig.value = componentList.value[index.value].config.baseConfig
                   setTimeout(()=>{
                    handleResize()
                   })
                }
            },{ deep: true }
        ) 
        onMounted(() => {
            // getInfo(props.yearRef)
            chartInit() 
            window.addEventListener('resize', handleResize);
        });
        onUnmounted(() => {
            window.removeEventListener('resize', handleResize);
        });
        const chartInit = ()=>{
            
            chartInstance.value = echarts.init(barChartRef.value);
            option.value =componentList.value[index.value].config.options
            option.value.series[0].data =componentList.value[index.value].data.echartsData
            chartInstance.value.setOption(option.value);
            
        }
        return{
            option,
            barChartRef,
            baseConfig

        }
    }
}
</script>

<style scoped>
.chart_box {position: relative;}
.chart1 {
    width: 100%;
   height: 100%;
   position: absolute;
}
</style>